import { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import http from 'hub-http/clients/apiClient';
import identity from 'transmute/identity';
import unescapedText from 'I18n/utils/unescapedText';
import ProsemirrorEditor from 'hubspot-prosemirror/prosemirror/ProsemirrorEditor';
import ContentOutputs from 'hubspot-prosemirror/prosemirror/editorCapabilities/ContentOutputTypes';
import { getPlaceholderPlugin } from 'hubspot-prosemirror/prosemirror/plugins/PlaceholderPlugin';
import { createSuggestionPlugin } from 'hubspot-prosemirror/prosemirror/plugins/suggestion';
import { TAG_MENTION } from 'hubspot-prosemirror/prosemirror/utils/mentionsUtil';
import { BLOCKQUOTE, BOLD, CLEAR_FORMATTING, ITALIC, LINK, LISTS, SNIPPETS, TEXT_ALIGN, UNDERLINE } from 'hubspot-prosemirror/prosemirror/editorCapabilities';
// @ts-expect-error untyped module customer-data-rte
import SnippetsApi from 'customer-data-rte/config/SnippetsApi';
import { getBodyFieldValidationMessage, getEditorText } from '../../utils/email';
import { StyledBodyField } from './StyledBodyField';
import memoize from 'transmute/memoize';
import { useEmailShareTabContext } from '../../context/EmailShareTabContext';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const snippetsApiClient = SnippetsApi(http);
const getStaticSuggestionPluginConfig = selectedToValue => {
  return createSuggestionPlugin({
    type: TAG_MENTION,
    allowSpace: true,
    getSuggestions: (text, done) => {
      return snippetsApiClient.searchSnippets({
        count: 20,
        offset: 0,
        query: text
      }).then(immutableSnippets => {
        done(immutableSnippets.get('results').toJS().map(snippet => ({
          searchText: snippet.name,
          text: snippet.name,
          id: snippet.contentId
        })));
      });
    },
    fetchSelectSuggestion: ({
      snippet,
      handleInsert
    }) => {
      return snippetsApiClient.fetchRenderedContent({
        id: snippet.id,
        contactVid: selectedToValue === null || selectedToValue === void 0 ? void 0 : selectedToValue.objectId
      }).then(renderedSnippet => {
        handleInsert({
          html: renderedSnippet.htmlBody
        });
      });
    }
  });
};
export const getBodyFieldEditorConfig = memoize(selectedToValue => {
  var _selectedToValue$prop, _selectedToValue$prop2;
  return {
    [BOLD]: {},
    [ITALIC]: {},
    [UNDERLINE]: {},
    [CLEAR_FORMATTING]: {},
    [TEXT_ALIGN]: {},
    [LISTS]: {},
    [LINK]: {},
    [SNIPPETS]: {
      onInsertContent: identity,
      onOpenPopover: identity,
      outputType: ContentOutputs.RENDERED,
      apiWrapper: SnippetsApi,
      // @ts-expect-error hubspot-prosemirror has conflicts with their typescript types and proptypes
      contactVid: selectedToValue === null || selectedToValue === void 0 ? void 0 : selectedToValue.objectId,
      contactEmail: (_selectedToValue$prop = selectedToValue === null || selectedToValue === void 0 || (_selectedToValue$prop2 = selectedToValue.properties) === null || _selectedToValue$prop2 === void 0 || (_selectedToValue$prop2 = _selectedToValue$prop2.email) === null || _selectedToValue$prop2 === void 0 ? void 0 : _selectedToValue$prop2.value) !== null && _selectedToValue$prop !== void 0 ? _selectedToValue$prop : ''
    },
    [BLOCKQUOTE]: {}
  };
});
export const BodyField = () => {
  const {
    bodyValue,
    updateBodyValue,
    selectedToValue
  } = useEmailShareTabContext();
  const [isFocused, setIsFocused] = useState(false);
  const plugins = useMemo(() => [getPlaceholderPlugin(unescapedText('CommerceToolsUiLib.shareToolModal.emailTab.bodyField.placeholder')), getStaticSuggestionPluginConfig(selectedToValue)], [selectedToValue]);
  const handleChange = useCallback(updatedEditorState => {
    updateBodyValue(updatedEditorState);
  }, [updateBodyValue]);
  const validationMessage = getBodyFieldValidationMessage(getEditorText(bodyValue));
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "100",
    children: /*#__PURE__*/_jsxs(StyledBodyField, {
      onFocus: () => setIsFocused(true),
      onBlur: () => setIsFocused(false),
      children: [/*#__PURE__*/_jsx(ProsemirrorEditor, {
        dataTestId: "email-share-tab-body-field",
        editorConfig: getBodyFieldEditorConfig(selectedToValue),
        editorState: bodyValue,
        setEditorState: handleChange,
        customPlugins: plugins,
        inputClassName: classNames(validationMessage ? "error" : isFocused && "focused")
      }), validationMessage && /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "200",
        as: "div",
        children: validationMessage
      })]
    })
  });
};